import React from 'react'
import { cn } from '../../utils/cn'
import { cva } from 'class-variance-authority'

const buttonVariants = cva(
  'w-8 h-2 mx-1 rounded-[6.25rem] flex align-center justify-center cursor-pointer',
  {
    variants: {
      variant: {
        default:
          'bg-carousel-pagination-default hover:bg-carousel-pagination-hover focus:bg-carousel-pagination-active',
        inverse:
          'bg-carousel-pagination-inverse-default hover:bg-carousel-pagination-inverse-hover focus:bg-carousel-pagination-inverse-active',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

interface PaginationProps {
  variant?: 'default' | 'inverse'
  isActive?: boolean
  className?: string
  onClick?: any
}

const Pagination = React.forwardRef<HTMLButtonElement, PaginationProps>(
  ({ variant, className, isActive, ...props }) => {
    return (
      <div
        className={cn(
          buttonVariants({
            variant,
            className: `${className} ${
              isActive &&
              (variant === 'inverse'
                ? 'bg-carousel-pagination-inverse-active hover:bg-carousel-pagination-inverse-active'
                : 'bg-carousel-pagination-active hover:bg-carousel-pagination-active')
            }`,
          })
        )}
        {...props}
      />
    )
  }
)

Pagination.displayName = 'Pagination'

export { Pagination, buttonVariants }
